import filesConfig from '@/assets/files'

export default (fileSlug) => {
  return filesConfig[fileSlug].data
}
